import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';

export const NO_INTERCEPT = new HttpContextToken<boolean>(() => false);

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {

  const isRegistrationPage = req.url.includes('/registro');
  const noIntercept = req.context.get(NO_INTERCEPT);
  // const isLocalhost = window.location.host.includes('localhost');

  if (!isRegistrationPage && !noIntercept) {
    const authToken = localStorage.getItem('authToken');

    if (authToken) {
      const clonedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      return next(clonedRequest);
    }
  }

  return next(req);
};
